import { Component, Vue } from 'vue-property-decorator'
import {
  queryAllTa, getMentorList, queryClassDetail, creatCommonTa, createMentorRelation,
  getImageByName, getUploadWebError, editCourseCode, queryStaticEvaluationClass,
  queryEvaluationStudent, queryEvaluationClass, editEvaluationStudent, editEvaluationClass,
  getWeekSendMessage, sendMessage, queryIpqSupervisorCommon, createSupervisor, inspectorEvaluationSummaryClass,
  queryApplyInfoByClass, editApplyInfo, editApplyApplys,
  addEvaluationInspector, editEvaluationInspector, getWeekStrPDF, exportWeekStrPDF, evaluationExport, createLecture, WXSendAccountMessage, insertProjectToApply, getFeedbackGetcontent
} from '@/api'
import feedBacktem from '@/components/feedBack/index.vue'
import urlBase from '@/utils/urlBase'
import html2canvas from 'html2canvas'
@Component({ name: 'class-detail-page', components: { feedBacktem } })
export default class ClassDetailPage extends Vue {
  private classId: any = null
  private pageData: any = null
  private taValue: any = ''
  private mentorValue: any = ''
  private supervisorValue: any = ''
  private taList: any = []
  private supervisorList: any = []
  private mentorList: any = []
  private time: any = null
  private time1: any = null
  private currentStudentPage: any = 1
  private currentApplyStudentPage: any = 1
  private allStudentPage: any = 1
  private activeStudent: any = 1
  private pageDataProgresList: any = null // 项目进度旧
  private pageDataProgresListCopy: any = null// 旧
  private dialogVisible: any = false
  private dialogImageUrl: any = null
  private uploadUrl = {
    // imgs: 'http://192.168.0.33:10069/upload/evaluation/image'
    imgs: urlBase.eduBaseUrl + 'upload/evaluation/image'
  }

  private loading: any = false
  private loading1: any = false
  private loading2: any = false
  private loading3: any = false
  private classWeekActive: any = null
  private studentTagsWeekActive: any = null
  private studentWeekActivestr: any = null
  private classFeedbackWeekList: any = null // 班级反馈周日期
  private studentFeedbackWeekList: any = null// 查询的周日期
  private studentFeedbackList: any = null // 学生反馈详情信息
  private studentFeedbackListcopy: any = null // 学生反馈详情信息
  private studentEvaluateList: any = null
  private tainfo: any = 'null'
  private messageType: any = null
  private weeksVisible: any = null
  private weekList: any = null
  private weeksradio: any = null
  private checkedWeeks: any = []
  private checkedWeeksStudent: any = []
  private activeStudentdata: any = []
  private activeApplyStudentdata: any = null
  private qualityList: any = [{}]
  private qualityListNull: any = [{}]
  private classFeedbackWeekListShow: any=[]
  private courseType: any = null
  private applyInfo: any = []
  private applySelectList: any = ['空', '有', '无', '待定', '不建议', '需学生自行与教授确认']
  private exportWeekFeedback: any = false
  private importWeeksList: any = []
  private exportDataPdf: any = null
  private exportDataPdfData: any = {}
  private allExportDataPdf: any = {}
  private exportcheckedWeeks: any = null
  private screenUrl: any = null
  private loading4: any = false
  private wsVisible: any = false
  private synchronousWsVisible: any = false
  private isToApply: any = false
  private synchronousWsInfoVisible: any = false
  private synchronousWsInfoData: any = null
  private studentEvaluateListWs: any = null
  created () {
    this.classId = this.$route.query.id
    this.initPageData() // 班级信息
  }

  private async initPageData () {
    const list: any = [{ path: '/class/relation/create/supervisor', pathName: 'createSupervisor' }, { path: '/class/relation/create/commonTa', pathName: 'creatCommonTa' },
      { path: '/class/relation/create/mentor', pathName: 'createMentorRelation' }, { path: '/wx/sendMessage', pathName: 'sendMessage' },
      { pathName: 'editEvaluationClass', path: '/evaluation/commonClass/edit/class' }, { pathName: 'editEvaluationStudent', path: '/evaluation/commonClass/edit/student' }]
    let result: any = await queryClassDetail({ id: this.classId, pathList: list })
    result = this.formatEditSwitch(result)
    this.pageData = result
    this.courseType = result?.class?.courseTypeId
    // 教研总监 有权改Mentor的list
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('教研总监') > -1)) {
      this.mentorList = await getMentorList({})
      const obj = this.mentorList.find((item: { name: any }) =>
        item.name === this.pageData.class.mentor
      )
      if (obj) {
        this.mentorValue = obj.id
      }
    }
    // 运营总监 有权改ta 和 Supervisor的list
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营总监') > -1 || item.indexOf('运营主管') > -1 || item.indexOf('运营专员') > -1)) {
      this.supervisorList = await queryIpqSupervisorCommon({})
      this.taList = await queryAllTa({})
      const taData: any = []
      const supervisorData: any = []
      // supervisorNames老师回显
      if (this.pageData.class.supervisor) {
        this.pageData.class.supervisor.forEach((item1: any) => {
          const obj = this.supervisorList.find((item: any) => item1 === item.name)
          if (obj) {
            supervisorData.push(obj.id)
          }
        })
        this.supervisorValue = supervisorData
      }
      // ta老师回显
      this.pageData.class.ta.forEach((item1: any) => {
        const obj = this.taList.find((item: any) => item1 === item.name)
        if (obj) {
          taData.push(obj.id)
        }
      })
      this.taValue = taData
    }
    this.getStaticEvaluationClass() // 获取反馈进度周日期
    // 回访内容
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('普通助教') < 0)) {
      const result1: any = await inspectorEvaluationSummaryClass({ classId: this.classId })
      this.qualityList = result1.inspector
      this.qualityList.forEach((item: any) => {
        if (!item.evaluation.length) {
          this.$set(item, 'evaluation', [{ detail: '' }])
        }
      })
      this.qualityListNull = JSON.parse(JSON.stringify(this.qualityList))
      // 学生回访分页
      this.allStudentPage = Math.ceil(this.qualityList.length / 13)
      this.activeStudentdata = this.qualityList[0]
    }

    if (this.$store.state.user.roles.find((item: any) => item.indexOf('普通助教') < 0)) {
      this.applyInfo = await queryApplyInfoByClass({ classId: this.classId })
      if (this.applyInfo.length > 0) {
        this.activeApplyStudentdata = this.applyInfo[0]
      }
      console.log('this.applyInfo: ', this.applyInfo)
    }
  }

  // 获取【班级反馈】和【学生反馈】list
  private async getStaticEvaluationClass () {
    const data: any = await queryStaticEvaluationClass({ classId: this.pageData.class.classId })
    this.classFeedbackWeekList = data.classWeekStr
    this.studentFeedbackWeekList = data.studentTag
    this.studentEvaluateList = data.student
    this.studentEvaluateListWs = JSON.parse(JSON.stringify(data.student))
    this.isToApply = data.isToApply
    // 班级学生分页
    // this.allStudentPage = Math.ceil(this.studentEvaluateList.length / 18)
    this.activeStudent = this.studentEvaluateList[0]
    // 班级反馈数据
    if (this.classFeedbackWeekList.length) {
      await this.classWeekClick(this.classFeedbackWeekList[0])
    }
    // 学生反馈数据
    if (this.studentFeedbackWeekList.length) {
      await this.studentTitleWeekClick(this.studentFeedbackWeekList[0])
    }
  }

  // 班级反馈周日期点击事件
  private async classWeekClick (item: any) {
    clearTimeout(this.time1)
    this.time1 = setTimeout(async () => {
      // 数据恢复初始值，以便于判断是否有修改。
      if (this.pageDataProgresList) {
        this.pageDataProgresList.forEach((item: any) => {
          if (!item.answer || item.answer.length < 1) {
            this.$set(item, 'answer', null)
          }
        })
      }
      if (this.pageDataProgresList && (JSON.stringify(this.pageDataProgresList) !== this.pageDataProgresListCopy)) {
        this.$confirm('您有修改未保存!', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          center: true
        }).then()
      } else {
        this.loading1 = true
        this.classWeekActive = item
        const result: any = await queryEvaluationClass({ weekStr: item, classId: this.pageData.class.classId })
        this.pageDataProgresList = result.questions
        this.pageDataProgresList.forEach((item: any) => {
          if (!item.answer && item.evaluationClass === '项目进度' && this.pageData.class.courseTypeId * 1 === 1) { // 项目进度默认值
            this.$set(item, 'answer', 'Content of Session I: \nContent of Session II:\nAssignment:\nAssignment DDL:')
          }
          if (!item.answer && item.evaluationClass === '项目进度' && (this.pageData.class.courseTypeId * 1 === 6 || this.pageData.class.courseTypeId * 1 === 32 || this.pageData.class.courseTypeId * 1 === 44)) { // 项目进度默认值
            this.$set(item, 'answer', '【主导师授课内容】: \n【副导师授课内容】:\n【本周作业】:\n【提交截止时间】:')
          }
          if (!item.answer && item.evaluationClass === '项目进度' && (this.pageData.class.courseTypeId * 1 === 45)) { // 项目进度默认值
            this.$set(item, 'answer', '【企业导师授课内容】: \n【实践助理授课内容】:\n【本周作业】:\n【提交截止时间】:')
          }
        })
        this.pageDataProgresListCopy = JSON.stringify(this.pageDataProgresList)
        this.loading1 = false
      }
    }, 100)
  }

  // 出勤--标题点击
  private async studentTitleWeekClick (item: any) {
    // 点击标签不自动切换到周一；
    const str = item.weekStr.find((item: any) => item === this.studentWeekActivestr)
    if (str) {
      this.studentWeekClick(str, item, null)
    } else {
      this.studentWeekClick(item.weekStr[0], item, null)
    }
  }

  // 学生反馈点击周日期事件--
  private async studentWeekClick (item: any, item1: any, studentitem: any) {
    // item 周日期序号, 学生反馈当前的周日期,
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      if (this.studentFeedbackList) this.Checkdata()
      if (this.studentFeedbackList && (JSON.stringify(this.studentFeedbackList) !== this.studentFeedbackListcopy)) {
        this.$confirm('您有修改未保存!', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          center: true
        }).then()
      } else {
        this.loading = true
        this.studentTagsWeekActive = item1 || this.studentTagsWeekActive // 反馈的当前标签
        this.activeStudent = studentitem || this.activeStudent // 学生反馈【评价】当前学生
        this.studentWeekActivestr = item
        let result: any = null
        if (!this.studentTagsWeekActive.showAllStudent) {
          result = await queryEvaluationStudent({ weekStr: item, classId: this.pageData.class.classId, tagName: this.studentTagsWeekActive.name, sellOrderId: this.activeStudent.sellOrderId })
        } else {
          result = await queryEvaluationStudent({ weekStr: item, classId: this.pageData.class.classId, tagName: this.studentTagsWeekActive.name })
        }
        this.studentFeedbackList = result.student
        this.studentFeedbackListcopy = JSON.stringify(this.studentFeedbackList)
        this.loading = false
      }
    }, 100)
  }

  private chertinput (item: any) {
    const t = /^[0-9./{1}]+$/
    if (!t.test(item.answer)) {
      this.$message({ message: '格式输入错误', type: 'info' })
      this.$nextTick(() => {
        item.answer = null
      })
    }
  }

  private getplaceholder (item: any) {
    let str = ''
    if (item.canEdit) {
      str = '请输入内容'
    }
    if (item.title === '预估成绩单出具时间') {
      str = '提交最终材料后的4-6周'
    }
    if (item.title === '资料提交清单') {
      str = `
      Submission checklist:
      Production log；
      Planning table/diagram；
      Literature table；
      Written Report (4500 words)；
      Presentation；
      Personal Information (Name Gender Birthday UCI (if available);
      Lecture Notes (Optional)；`
    }
    return str
  }

  private async clickitemradio (e: any, item3: any, list: any) {
    // console.log(e, item3, '+++item12939399393++++++', list, this.pageData.class.courseTypeId)
    if (item3.canEdit) {
      item3.answer && (e === item3.answer) ? item3.answer = null : item3.answer = e
      // 全球华人导师/全球华人导师香港/全球华人导师海外/线下导师项目
      const courseTypeIdList = [6, 32, 39, 44]
      if (courseTypeIdList.includes(this.pageData.class.courseTypeId)) {
        // 过滤国内 Teaching Fellow/出勤，报告进展'的数组拼接参数
        const result = list.filter((item: any) =>
          item.questionClass === 'Teaching Fellow' &&
            (item.title === '出勤' || item.title === '报告进展')
        )
        const searchEvaluateObj: any = {
          studentId: item3.studentId,
          studentName: item3.studentName,
          classId: this.pageData.class.classId,
          weekStr: this.studentWeekActivestr
        }
        // 循环当前评价模块的所有选项
        const fieldMap: any = {
          出勤: 'isAttendanceNormal',
          报告进展: 'progressStatus'
        }
        result.forEach((itemAnswer: any) => {
          const targetKey = fieldMap[itemAnswer.title]
          if (targetKey && itemAnswer.answer) {
            searchEvaluateObj[targetKey] = itemAnswer.answer * 1
          }
        })
        const loading: any = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading'
        })
        const res: any = await getFeedbackGetcontent(searchEvaluateObj)
        const index = list.findIndex((item1: any) => item1.questionClass === 'Teaching Fellow' && item1.title === 'Suggestions or others')
        if (index > -1) {
          this.$set(list[index], 'answer', res.finalFeedback)
        }
        loading.close()
      }
      // 海外小组科研
      const courseTypeIdList1 = [1]
      if (courseTypeIdList1.includes(this.pageData.class.courseTypeId)) {
        if (item3.title === '是否为workshop' && item3.answer) {
          const titles = ['final类型']
          list.forEach((item: any) => {
            if (item.questionClass === 'TA' && titles.includes(item.title)) {
              this.$set(item, 'isHide', item3.answer * 1 === 2 ? true : '')
              this.$set(item, 'answer', null)
            }
          })
        }
        if (item3.title === 'final类型') {
          list.forEach((item: any) => {
            if (item.title === '学生贡献度') {
              this.$set(item, 'answer', null)
              this.$set(item, 'isHide', item3.answer * 1 !== 1)
            }
            if (item.title === 'final进度') {
              this.$set(item, 'answer', null)
              this.$set(item, 'isHide', !item3.answer)
              item.chooseList.forEach((item2: any) => {
                if (item2.id * 1 === 4) {
                  item2.isHide = item3.answer * 1 === 2
                }
              })
            }
          })
        }
        const titleList = [
          { key: '出勤', value: 'isAttendanceNormal' },
          { key: '互动', value: 'interactionStatus' },
          { key: '学生在OH的表现好', value: 'officeHourStatus' },
          { key: '学生微信问过助教问题', value: 'wechatQuestionStatus' },
          { key: '学生在Univ AI主动提问', value: 'univAIQuestionStatus' },
          { key: '学生在Univ AI平台回应别人帖子', value: 'univAIResponseStatus' },
          { key: '是否为workshop', value: 'isWorkshop' },
          { key: 'final类型', value: 'finalType' },
          { key: 'final进度', value: 'finalProgress' },
          { key: '学生贡献度', value: 'hasInstructorFeedback' }
        ]
        const result = list.filter((item: any) =>
          item.questionClass === 'TA' &&
          titleList.some(t => t.key === item.title)
        )
        const searchEvaluateObj1: any = {
          studentId: item3.studentId,
          studentName: item3.studentName,
          // studentName: this.studentEvaluateListWs.find((item: any) => item.id === item3.studentId) ? this.studentEvaluateListWs.find((item: any) => item.id === item3.studentId).studentNameEn : item3.studentName,
          classId: this.pageData.class.classId,
          weekStr: this.studentWeekActivestr
        }
        result.forEach((itemAnswer: any) => {
          const itemIndex: any = titleList.findIndex(item => item.key === itemAnswer.title && itemAnswer.answer)
          if (itemIndex > -1) {
            this.$set(searchEvaluateObj1, titleList[itemIndex].value, itemAnswer.answer * 1)
          }
        })
        const loading: any = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading'
        })
        const res: any = await getFeedbackGetcontent(searchEvaluateObj1)
        const index = list.findIndex((item1: any) => item1.questionClass === 'TA' && item1.title === '学生表现')
        if (index > -1) {
          this.$set(list[index], 'answer', res.finalFeedback)
        }
        loading.close()
      }
    }
  }

  private getIsShow (item3: any, list: any) {
    // 海外小组科研
    const courseTypeIdList1 = [1]
    if (courseTypeIdList1.includes(this.pageData.class.courseTypeId)) {
      const titles = ['final类型', 'final进度', '学生贡献度']
      const titles1 = ['final进度']
      const titles2 = ['学生贡献度']
      if (item3.questionClass === 'TA' && titles.includes(item3.title) && list.find((item4: any) => item4.title === '是否为workshop' && item4.answer * 1 !== 1)) {
        // this.$set(item3, 'isHide', true)
        return false
      } else if (item3.questionClass === 'TA' && titles1.includes(item3.title) && list.find((item4: any) => item4.title === 'final类型' && !item4.answer)) {
        // this.$set(item3, 'isHide', true)
        return false
      } else if (item3.questionClass === 'TA' && titles2.includes(item3.title) && list.find((item4: any) => item4.title === 'final类型' && item4.answer * 1 !== 1)) {
        // this.$set(item3, 'isHide', true)
        return false
      } else {
        return !item3.isHide
      }
    } else {
      return !item3.isHide
    }
  }

  private questionta (item: any) {
    if (item.answer) {
      let len = 0
      for (let i = 0; i < item.answer.length; i++) {
        const c = item.answer.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
      }
      // 海外小组科研 评价是调接口生成的
      if (len < 600 && this.pageData.class.courseTypeId * 1 !== 1) {
        this.$message({ message: 'TA评价不可少于600个字符', type: 'warning' })
        const pwdElem: any = this.$refs.TAinput
        pwdElem[0].focus()
        this.tainfo = false
      } else {
        this.tainfo = true
      }
    }
  }

  private Checkdata () { // 数据修改清空时为‘’，原始值null,对比的时候会不等有，恢复初始值null
    this.studentFeedbackList.forEach((item: any) => {
      if (item.questionClassList.length) {
        item.questionClassList.forEach((item1: any) => {
          if (item1.question) {
            item1.question.forEach((item2: any) => {
              if (!item2.answer || item2.answer.length < 1) {
                item2.answer = null
              }
            })
          }
        })
      }
    })
  }

  private studentItemClick (item: any) {
    this.studentWeekClick(this.studentWeekActivestr, null, item)
  }

  private toKb () {
    this.$router.push({ path: '/student/schedule', query: { classId: this.pageData.class.classId, className: this.pageData.class.className } })
  }

  private onStudentClick (student: any) {
    const { id } = student
    // 1 学员 2 论文 3 异常
    this.$router.push({ path: '/student/detail', query: { id: id, detailType: '1' } })
  }

  formatEditSwitch (data: any) {
    for (const index in data.progress) {
      data.progress[index].edit = false
    }
    return data
  }

  private async saveProjectPagedata () {
    if (this.pageDataProgresListCopy === JSON.stringify(this.pageDataProgresList)) {
      this.$message({ message: '无任何修改', type: 'warning' })
      return
    }
    const { error }: any = await editEvaluationClass({ questions: this.pageDataProgresList })
    if (!error) {
      this.$message({ message: '保存成功', type: 'success' })
      this.pageDataProgresList = null
      this.classWeekClick(this.classWeekActive)
    }
  }

  private async saveStudentFeedback () {
    if (!this.tainfo) { return }
    // if (JSON.stringify(this.studentFeedbackList) === this.studentFeedbackListcopy) {
    //   this.$message({ message: '无任何修改', type: 'warning' })
    //   return
    // }
    const { error }: any = await editEvaluationStudent({ student: this.studentFeedbackList })
    if (!error) {
      this.studentFeedbackList = null
      this.$message({ message: '保存成功', type: 'success' })
      this.tainfo = 'null'
      this.studentWeekClick(this.studentWeekActivestr, null, null)
    }
  }

  private async savePagedata () {
    // ta修改 Supervisor修改
    if (this.pageData.class.supervisorCanChange && this.pageData.class.courseTypeId === 30) {
      const param: any = {
        classId: this.pageData.class.classId,
        supervisorId: this.supervisorValue
      }
      const { error }: any = await createSupervisor(param)
      if (!error) {
        this.$message({ message: '保存成功', type: 'success' })
      }
    }
    if (this.pageData.class.TaCanChange && this.pageData.class.courseTypeId !== 30) {
      // 修改Supervisor修改
      const param: any = {
        classId: this.pageData.class.classId,
        taId: this.taValue
      }
      const { error }: any = await creatCommonTa(param)
      if (!error) {
        this.$message({ message: '保存成功', type: 'success' })
      }
    }
    // menter修改
    if (this.pageData.class.mentorCanChange && this.$store.state.user.roles.find((item: any) => item.indexOf('教研总监') > -1)) {
      const param1: any = {
        classId: [this.pageData.class.classId],
        mentorId: this.mentorValue
      }
      const { error }: any = await createMentorRelation(param1)
      if (!error) {
        this.$message({ message: '保存成功', type: 'success' })
      }
    }
  }

  private handleRemove (obj: any, file: any, fileList: any) {
    if (fileList && fileList.length && fileList.find((item: any) => item.status !== 'success')) return
    const list: any = []
    if (fileList.length) {
      fileList.forEach((element: any) => {
        const obj1: any = {}
        obj1.name = element.name
        obj1.url = element.response ? element.response.data.url : element.url
        list.push(obj1)
      })
    }
    obj.answer = list
  }

  private async handleupload (file: any) {
    this.loading2 = this.$loading({
      lock: true,
      text: '拼命加载中',
      spinner: 'el-icon-loading'
    })
    return true
  }

  private async handleSuccess (obj: any, response: any, file: any, fileList: any) {
    if (response === 'ok' || file.response === 'ok') {
      await getUploadWebError(file)
    }
    if (fileList && fileList.length && fileList.find((item: any) => item.status !== 'success')) return
    const list: any = []
    if (fileList.length) {
      fileList.forEach((element: any) => {
        const obj1: any = {}
        obj1.name = element.name
        obj1.url = element.response ? element.response.data.url : element.url
        list.push(obj1)
      })
    }
    obj.answer = list
    this.loading2.close()
  }

  private handlePictureCardPreview (file: any) {
    this.dialogImageUrl = file.url
    this.dialogVisible = true
  }

  private async refreshImg (item: any) {
    const data: any = await getImageByName({ name: item.name })
    if (data && data.url) {
      this.$set(item, 'url', data.url)
    } else {
      this.$message({ message: '刷新失败', type: 'error' })
    }
  }

  private deletePreview1 (item: any, index: any) {
    item.answer.splice(index, 1)
  }

  private mouseOver (item: any) {
    this.$set(item, 'isShowIcon', true)
  }

  private mouseLeave (item: any) {
    this.$set(item, 'isShowIcon', false)
  }

  private async sureSendClick (type: any) {
    if (type === 3) {
      this.wsVisible = true
      this.checkedWeeksStudent = this.pageData.students.map((item: any) => item.id)
    } else {
      if (this.pageDataProgresList && (JSON.stringify(this.pageDataProgresList) !== this.pageDataProgresListCopy)) {
        this.$confirm('您有修改未保存!', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          center: true
        }).then()
        return
      }
      this.messageType = type
      const data: any = await getWeekSendMessage({
        messageType: this.messageType,
        classId: this.pageData.class.classId,
        isCurrentClass: true
      })
      this.checkedWeeksStudent = this.pageData.students.map((item: any) => item.id)
      this.weekList = data.weekStrList
      this.weeksVisible = true
    }
  }

  private async sureSend () {
    const list: any = []
    this.checkedWeeks.forEach((item: any) => {
      list.push(item.weekStr)
    })
    const { error }: any = await sendMessage({
      classId: this.pageData.class.classId,
      weekStr: this.messageType === 1 ? [this.weeksradio] : list,
      messageType: this.messageType,
      studentIds: this.checkedWeeksStudent,
      isCurrentClass: true
    })
    if (!error) {
      const text = this.messageType === 1 ? '发布成功' : '更新成功'
      this.weeksVisible = false
      this.$message({ message: text, type: 'success' })
      this.reseat()
    }
  }

  sureSendWs () {
    this.$confirm('确认推送网申消息？', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(() => {
      const { error }: any = WXSendAccountMessage({ classId: this.pageData.class.classId, studentIds: this.checkedWeeksStudent })
      if (!error) {
        this.checkedWeeksStudent = []
        this.wsVisible = false
        this.$message({ message: '推送成功', type: 'success' })
      }
    }).catch()
  }

  private reseat () {
    this.checkedWeeksStudent = []
    this.checkedWeeks = []
    this.weeksVisible = false
    this.weekList = []
    this.weeksradio = null
    this.wsVisible = false
    this.synchronousWsVisible = false
  }

  private async changeCourseCode () {
    await editCourseCode({ classId: this.pageData.class.classId, courseCode: this.pageData.class.courseCode })
    this.$message({ message: '修改Course Code成功', type: 'success' })
  }

  private async addQuality (item1: any, item: any) {
    if (!item1.detail) {
      this.$message({ message: '请输入内容，并保存', type: 'error' })
    } else {
      item.evaluation.push({ detail: '' })
    }
  }

  private async saveApplyInfo (item: any) {
    // const { error }: any = await editApplyInfo(item)
    const { error }: any = await editApplyApplys({ applyData: this.applyInfo })
    if (!error) {
      this.$message({ message: '网申资格修改成功', type: 'success' })
    }
    // this.$message({ message: '网申资格修改成功', type: 'success' })
  }

  private async saveQuality (item1: any, item: any) {
    if (!item1.detail) {
      this.$message({ message: '请输入内容', type: 'error' })
    } else {
      if (item1.id) {
        const { error }: any = await editEvaluationInspector({ id: item1.id, detail: item1.detail })
        if (!error) {
          this.$message({ message: '修改回访成功', type: 'success' })
        }
      } else {
        const { error }: any = await addEvaluationInspector({ classId: this.pageData.class.classId, sellOrderId: item.sellOrderId, detail: item1.detail })
        if (!error) {
          this.$message({ message: '新增回访成功', type: 'success' })
        }
      }
    }
  }

  private async exportpdf () {
    const data: any = await getWeekStrPDF({ classId: this.classId })
    this.exportWeekFeedback = true
    this.importWeeksList = data
  }

  private async sureImport (index: any) {
    // 循环学生列表导出
    if (index >= this.pageData.students.length) {
      this.loading3.close()
      return
    }
    this.loading3 = this.$loading({
      lock: true,
      text: '导出中...',
      spinner: 'el-icon-loading'
    })
    const item = index ? this.pageData.students[index] : this.pageData.students[0]
    this.exportDataPdf = null
    this.exportDataPdfData = {}
    this.exportWeekFeedback = false
    const data: any = await exportWeekStrPDF({ classId: this.classId, sellOrderId: item.sellOrderId, all: false, weeks: [this.exportcheckedWeeks] })
    if ((data && data.singleWeek) || (data && data.error.returnCode === 0)) {
      this.exportDataPdfData = data
      await this.getexportpdf(item, index)
      await evaluationExport({ studentName: item.name })
    } else {
      setTimeout(async () => {
        await this.sureImport(index * 1 + 1)
      }, 2000)
    }
  }

  // html2canvas 截图不支持 svg处理
  private async convertSvg2Canvas (type: any) {
    let svgElms: any = []
    if (type === 1) {
      svgElms = document.getElementsByClassName('exportDataPdfAll')[0].getElementsByTagName('svg')
    } else {
      svgElms = document.getElementsByClassName('exportDataPdf')[0].getElementsByTagName('svg')
    }
    // 回调
    const callbacks = []
    for (const svg of svgElms) {
      const parentElement: any = svg.parentElement
      if (parentElement.getElementsByTagName('canvas').length === 1) {
        return
      }
      const img = new Image()
      img.src = `data:image/svg+xml,${encodeURIComponent((new XMLSerializer()).serializeToString(svg))}`
      img.crossOrigin = 'anonymous'
      img.onload = async () => {
        const width = 180 // 圆形进度条宽度
        const height = 180
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx: any = canvas.getContext('2d')
        await ctx.drawImage(img, 0, 0, width, height)
        parentElement.append(canvas)
        svg.remove()
        img.remove()
      }
      // 代码
      // parentElement.append(img)
      callbacks.push(img.onload)
    }
    await Promise.all(callbacks)
  }

  // html2canvas 截图不支持 svg处理
  private checkScriptLoaded (src: any) {
    const scriptObjs = Array.from(document.getElementsByTagName('script'))
    return scriptObjs.find(ele => ele.src.includes(src))
  }

  // html2canvas 截图不支持 svg处理
  private async loadScript (src: any, callback = null) {
    await new Promise(resolve => {
      // 如果已经加载了本js，直接调用回调
      if (this.checkScriptLoaded(src)) {
        return resolve(callback)
      }
      const scriptNode: any = document.createElement('script')
      scriptNode.setAttribute('type', 'text/javascript')
      scriptNode.setAttribute('src', src)
      document.body.appendChild(scriptNode)
      if (scriptNode.readyState) { // IE 判断
        scriptNode.onreadystatechange = () => {
          if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
            return resolve(callback)
          }
        }
      } else {
        scriptNode.onload = () => resolve(callback)
      }
    })
  }

  private async getexportpdf (item1: any, index: any) {
    // 选择多个周日期下载图片
    if (this.exportDataPdfData.singleWeek && this.exportDataPdfData.singleWeek.length) {
      this.exportDataPdf = this.exportDataPdfData.singleWeek
      this.$nextTick(async () => {
        await Promise.all([this.loadScript('/static/js/html2canvas.min.js'), this.convertSvg2Canvas(2)]).then(async () => {
          const refs: any = this.$refs
          if (refs.exportpdf[0]) {
            setTimeout(() => {
              this.downloadPDF(refs.exportpdf[0], item1.name + '第' + this.exportDataPdf[0].weekStr + '节反馈', index)
            }, 1000)
            // this.downloadPDF(refs.exportpdf[0], item1.name + '第' + this.exportDataPdf[0].weekStr + '节反馈', index)
          }
          //   const refs: any = this.$refs
          //   if (refs.exportpdf[0]) {
          //     await this.downloadPDF(refs.exportpdf[0], item1.name + '第' + this.exportDataPdf[0].weekStr + '周反馈')
          //   }
        })
      })
    } else {
      this.loading3.close()
    }
  }

  // 把页面导出PDF
  private async downloadPDF (ele: any, pdfName: any, index: any) {
    window.scrollTo(0, 0)
    html2canvas(ele, {
      useCORS: true,
      scale: ele.offsetHeight > 5000 ? 1.2 : 2,
      allowTaint: false
    }).then(async (canvas) => {
      const pageData: any = canvas.toDataURL('image/png', 1.0)
      this.screenUrl = pageData
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      a.download = pdfName
      a.href = this.screenUrl
      await a.dispatchEvent(event)
      await this.sureImport(index * 1 + 1)
    })
  }

  private getWeekStr (week: any) {
    const list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十']
    const list1 = ['Session One', 'Session Two', 'Session Three', 'Session Four', 'Session Five', 'Session Six', 'Session Seven', 'Session Eight', 'Session Nine', 'Session Ten', 'Session Eleven', 'Session Twelve', 'Session Thirteen', 'Session Fourteen', 'Session Fifteen', 'Session Sixteen', 'Session Seventeen', 'Session Eighteen', 'Session Nineteen', 'Session Twenty']
    if (this.pageData.class.courseTypeId * 1 !== 31 && this.pageData.class.courseTypeId * 1 !== 30) {
      // return `第${week}节`
      const index = list.findIndex(item => week === item)
      if (index !== -1 && this.pageData.class.courseTypeId === 1) {
        return `第${week}节` + ' ' + list1[index]
      }
      return `第${week}节`
    } else if (this.pageData.class.courseTypeId * 1 === 30) {
      return `第${week}周`
    }
    return `第${week}节`
  }

  private makeWeekStr (weekStr: any) {
    if (this.courseType !== 31 && this.courseType !== 30) {
      return `第${weekStr}节`
    } else if (this.courseType === 30) {
      return `第${weekStr}周`
    }
    return `第${weekStr}节`
  }

  // private async clickActiveStudent() {
  //    if(this.qualityListNull !== this.qualityList) {
  //     this.$message({ message: '修改回访成功', type: 'success' })
  //   }
  // }

  private getFeedBackTitle (title: any) {
    if (title === 'Lecture') {
      return 'Session l'
    } else if (title === 'Mentor Session') {
      return 'Session II'
    }
    return title
  }

  private async addLecture (type: any) {
    if (this.studentFeedbackList && (JSON.stringify(this.studentFeedbackList) !== this.studentFeedbackListcopy)) {
      this.$confirm('您有修改未保存!', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning',
        center: true
      }).then()
      return
    }
    const str = '确认新增Lecture出勤?'
    const str1 = '确认新增Lecture摄像头?'
    this.$confirm(type === 1 ? str : str1, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const str = 'Lecture' + String(this.studentFeedbackList[0].questionClassList.length + 1)
      // 学生反馈数据
      const obj = {
        weekStr: this.studentWeekActivestr,
        classId: this.classId,
        lectureName: str,
        type: type === 1 ? 'lecture' : 'camera'
      }
      const { error }: any = await createLecture(obj)
      if (!error) {
        this.$message({ message: '新增Lecture成功', type: 'success' })
      }
      if (this.studentFeedbackWeekList.length) {
        const index = type === 1 ? 0 : 1
        await this.studentTitleWeekClick(this.studentFeedbackWeekList[index])
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消'
      })
    })
  }

  private reseatWS () {
    this.studentEvaluateListWs = JSON.parse(JSON.stringify(this.studentEvaluateList))
    this.synchronousWsVisible = false
  }

  private async sureAsyncSendWs () {
    const loading = this.$loading({
      lock: true,
      text: '拼命加载中',
      spinner: 'el-icon-loading'
    })
    const obj = {
      classId: this.classId,
      students: this.studentEvaluateListWs.map((item: any) => ({ studentId: item.id, studentNameEn: item.studentNameEn }))
    }
    const { error, data }: any = await insertProjectToApply(obj)
    loading.close()
    if (error && (error.returnCode * 1 === 0)) {
      this.synchronousWsInfoData = data
      this.synchronousWsInfoVisible = true
      this.isToApply = true
    }
    this.synchronousWsVisible = false
  }
}
